import * as yup from 'yup';
import { DateTime } from 'luxon';

export const validationSchema = yup.object().shape({
  numberAllowed: yup.string().required('Il campo è obbligatorio'),
  type: yup.string().required('Il campo è obbligatorio'),
  dateRelease: yup
    .date()
    .typeError('Data non valida')
    .required('Il campo obbligatorio')
    .max(DateTime.now().endOf('day'), 'La data deve essere minore o uguale del giorno corrente'),
  dateDeclaration: yup
    .date()
    .typeError('Data non valida')
    .required('Il campo è obbligatorio')
    .when('dateRelease', (dateRelease, formvalidationSchema) =>
      dateRelease && dateRelease?.toString() !== 'Invalid Date'
        ? formvalidationSchema
            .min(dateRelease, 'La data deve essere maggiore della data di rilascio')
            .max(DateTime.now(), 'La data deve essere minore del giorno corrente')
        : formvalidationSchema.nullable()
    ),
  dateExpiration: yup
    .date()
    .typeError('Data non valida')
    .required('Il campo è obbligatorio')
    .when('dateRelease', (dateRelease, schema) => {
      if (dateRelease && dateRelease?.toString() !== 'Invalid Date') {
        const dayAfter = new Date(dateRelease.getTime() + 86400000);
        return schema.min(dayAfter, 'La data deve essere maggiore della data di rilascio');
      } else {
        return schema.nullable();
      }
    }),
  municipality: yup.object().shape({
    description: yup.string().required('Il campo è obbligatorio'),
  }),
  note: yup
    .string()
    .nullable()
    .when('type', (type, formvalidationSchema) =>
      type === '9'
        ? formvalidationSchema.required(
            'Per tipo soggiorno non conosciuto/non fornito è obbligatorio valorizzare il campo note'
          )
        : formvalidationSchema.nullable()
    ),
});
